import './SiteDetailView.scss';

export { default } from './SiteDetailView';
